export default function ({ app }) {
  const locale = app.i18n.locale || "en"
  app.head.htmlAttrs = {
    lang: locale
  }
}
